import { createClient } from "@supabase/supabase-js";

export const supabaseClient = createClient(
	process.env.REACT_APP_SUPABASE_URL,
	process.env.REACT_APP_SUPABASE_API_URL
);

export const supabaseGetImageUrl = async (filename) => {
	const {
		data: { publicUrl },
	} = supabaseClient.storage
		.from("skills")
		.getPublicUrl(`public/${filename}`);

	return { publicUrl };
};
